module.exports = __webpack_public_path__ + "static/media/fa-brands-400.659c4d58.woff2";